"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getToken = void 0;
var legacyKey = 'token';
var oktaKey = 'okta-token-storage';

var getToken = function getToken() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var search = new URL(window.location).searchParams;
  var searchToken = search.get('token');

  if (searchToken) {
    return searchToken;
  }

  if (options.tokenKey) {
    return JSON.parse(window.localStorage.getItem(options.tokenKey));
  }

  var oktaToken = JSON.parse(window.localStorage.getItem(oktaKey));

  if (oktaToken) {
    var accessToken = oktaToken.accessToken;
    return accessToken && accessToken.accessToken;
  }

  return JSON.parse(window.localStorage.getItem(legacyKey));
};

exports.getToken = getToken;